var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/core-js/modules/_html.js
// module id = 96
// module chunks = 1